<template lang="pug">
  .search-control-container(:class="getClass()" v-show="getShowSearchList")
    v-list.pt-0.searcher-list-options
      v-list-tile(
        v-for="refugio in filterAlberges"
        :key="`refugio-${refugio.nro}`"
        @click="redirectToSelectedItem(refugio, 'refugio')"
        )
        v-list-tile-content
          v-list-tile-title {{ refugio.nombre.toUpperCase() }}
      v-list-tile(
        v-for="project in filterProjects"
        :key="`project-${project.code}`"
        @click="redirectToSelectedItem(project, 'project')")
        v-list-tile-content
          v-list-tile-title {{ project.name.toUpperCase() }}
      //- v-list-tile(
      //-   v-for="(subproject, index) in filterSubprojects"
      //-   :key="`subproject-${index}`"
      //-   @click="redirectToSelectedItem(subproject, 'subproject')")
      //-   v-list-tile-content
      //-     v-list-tile-title {{ subproject.name.toUpperCase() }}
      v-list-tile(
        v-for="centroMunicipal in filterCentrosMunicipales"
        :key="`centroMunicipal-${centroMunicipal.id}`"
        @click="redirectToSelectedItem(centroMunicipal, 'centroMunicipal')")
        v-list-tile-content
          v-list-tile-title {{ centroMunicipal.centros_municipales.toUpperCase() }}
      v-list-tile(
        v-for="institucion in filterInstituciones"
        :key="`institucion-${institucion.id}`"
        @click="redirectToSelectedItem(institucion, 'institucion')")
        v-list-tile-content
          v-list-tile-title {{ institucion.institucion_afectada.toUpperCase() }}
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ProjectService from '@/services/projects.js'

export default {
  computed: {
    ...mapGetters([
      'dataWithShapesByProjectList',
      'getAllCentrosMunicipales',
      'getAllInstituciones',
      'getAllRefugios',
      'getAllSubprojects',
      'getSearchText',
      'getShowSearchList',
      'hrefify',
      'isSolucionACortoPlazo',
      'isSolucionDefinitiva'
    ]),
    ...mapGetters({
      state: 'interfaceState'
    }),
    filterAlberges () {
      let searching = new RegExp(this.getSearchText.toString().toLowerCase())
      return this.alberguesList.map(albergue => albergue)
        .filter(albergue => albergue.nombre.toString().toLowerCase().match(searching))
    },
    filterCentrosMunicipales () {
      let searching = new RegExp(this.getSearchText.toString().toLowerCase())
      return this.centrosMunicipalesList.map(centroMunicipal => centroMunicipal)
        .filter(centroMunicipal => centroMunicipal.centros_municipales.toString().toLowerCase().match(searching))
    },
    filterInstituciones () {
      let searching = new RegExp(this.getSearchText.toString().toLowerCase())
      return this.institucionesList.map(institucion => institucion)
        .filter(institucion => institucion.institucion_afectada.toString().toLowerCase().match(searching))
    },
    filterProjects () {
      if (!this.projectList || !this.projectList.length) return []
      let searching = new RegExp(this.getSearchText.toString().toLowerCase())
      return this.projectList.map((project) => project)
        .filter(project => project.name.toString().toLowerCase().match(searching))
    },
    filterSubprojects () {
      if (!this.projectList || !this.projectList.length) return []
      let searching = new RegExp(this.getSearchText.toString().toLowerCase())
      // return this.subprojectList.map((subproject) => subproject)
      //   .filter(subproject => subproject.name.toString().toLowerCase().match(searching))
      return this.projectList.map((project) => {
        if (project.componentes) {
          return { 'componentes': project.componentes, 'code': project.code }
        }
      })
        .filter(subprojects => {
          if (subprojects) {
            return subprojects.componentes.map(subproject => {
              return subproject.name.toString().toLowerCase().match(searching)
            })
          }
        })
    }
  },
  data: () => ({
    alberguesList: [],
    centrosMunicipalesList: [],
    findList: [],
    projectList: [],
    institucionesList: [],
    subprojectList: []
  }),
  methods: {
    ...mapActions([
      'loadRefugios',
      'setActivateTab',
      'setCurrentRefugioAndUpdateRoute',
      'setInstitucionAndUpdateRoute',
      'setCentroMunicipalAndUpdateRoute',
      'setProjectInfoAndUpdateRoute',
      'setSearchText',
      'setShowSearchList'
    ]),
    getClass () {
      return this.isInHeader ? 'isInHeader' : ''
    },
    loadProjectList () {
      ProjectService.getProjects(this.$http, this.apiKey).then(projects => {
        this.projectList = projects
        this.dataWithShapesByProjectList(this.projectList)
      })
    },
    loadCentrosMunicipalesList () {
      this.getAllCentrosMunicipales.then(response => {
        if (!response.features || !response.features.length) return
        response.features.map(feature => {
          this.centrosMunicipalesList.push(feature.properties)
        })
      })
    },
    loadInsitucionesList () {
      this.getAllInstituciones.then(response => {
        if (!response.features || !response.features.length) return
        response.features.map(feature => {
          this.institucionesList.push(feature.properties)
        })
      })
    },
    loadAlberguesList () {
      this.getAllRefugios.then(response => {
        if (!response.features || !response.features.length) return
        response.features.map(feature => {
          this.alberguesList.push(feature.properties)
        })
      })
    },
    loadSubprojectList () {
      setTimeout(() => {
        this.getAllSubprojects().then(response => {
          this.subprojectList = response
        })
      })
    },
    redirectToSelectedItem (item, itemType) {
      this.setShowSearchList(false)
      this.setSearchText('')
      this.$emit('clearSearch')

      switch (itemType) {
        case 'centroMunicipal':
          this.setCentroMunicipalAndUpdateRoute({ centroMunicipal: item })
          break
        case 'institucion':
          this.setInstitucionAndUpdateRoute({ institucion: item })
          break
        case 'project':
          this.setProjectInfoAndUpdateRoute({ projectInfo: item })
          break
        case 'refugio':
          this.setCurrentRefugioAndUpdateRoute({ refugio: item })
          setTimeout(() => {
            this.setCurrentRefugioAndUpdateRoute({ refugio: item })
            setTimeout(() => {
              this.setCurrentRefugioAndUpdateRoute({ refugio: item })
            }, 500)
          })
          break
        case 'subproject':
          this.$router.push({ name: 'map', query: { code: item.code, tab: 'subproyectos' } })
          break
      }
    }
  },
  mounted () {
    this.loadAlberguesList()
    this.loadProjectList()
    this.loadCentrosMunicipalesList()
    this.loadInsitucionesList()
    this.loadSubprojectList()
  },
  props: {
    search: {
      default: '',
      type: String
    },
    isInHeader: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    getSearchText () {
      if (this.getSearchText && this.getSearchText !== '') {
        this.setShowSearchList(true)
      } else {
        this.setShowSearchList(false)
      }
    }
  }
}

</script>

<style lang="stylus" scoped>
  @media screen and (min-width: 500px) and (max-width: 812px) and (max-height: 500px) and (orientation: landscape)
    .search-control-container
      margin-top: 20vh !important
  .search-control-container .searcher-list-options
    border-radius: 0 0 20px 20px;
  .search-control-container
    display: flex
    height: 80vh
    justify-content: center
    margin-top: 13vh
    overflow: auto
    width: 100%
    &.isInHeader
      border: 0;
      height: auto
      max-height: 210px
      margin-left: 0;
      margin-top: 1px;
      padding: 0;
      width: 100%;
      .searcher-list-options
        border: 0
        border-radius: 10px
        margin-top: 1px
        padding: 0
        width: 100%
    .search-control
      display: flex
      width: 100%
      padding-left: 42px
      input
        width: inherit
        outline: none
    .searcher-list-options
      border: 2px solid darkgray
      display: flex
      flex-direction: column
      overflow: auto
      width: 89%
      z-index: 999
</style>
